import { render, staticRenderFns } from "./role_user.vue?vue&type=template&id=f74de31a&"
import script from "./role_user.vue?vue&type=script&lang=js&"
export * from "./role_user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports